import React from 'react';

import { Box, Chip, MenuItem, Select } from '@mui/material';

import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

export const CommentContainer = ({
  register, 
  control, 
  watch, 
  setValue
}) => {
  const {t} = useTranslation();

  const listStreetUsageOptions = [
    { value: 'go_to_work', label: t('criteria.street_usage_work') },
    { value: 'go_to_school', label: t('criteria.street_usage_school') },
    { value: 'go_to_market', label: t('criteria.street_usage_market') },
    { value: 'take_a_walk', label: t('criteria.street_usage_walk') },
    { value: 'other', label: t('criteria.street_usage_other') }
  ];

  const withStreetUsage = useSelector(state => state.init.withStreetUsage);
  const surveyWithComment = useSelector(state => state.init.withComment);

  const valueStreetUsage = watch('street_usages') || [];
  
  const handleChange = (event) => {
    const value = event.target.value;
    setValue('street_usages', value);
  };

  const handleDelete = (valueToRemove) => {
    const valueToSet = valueStreetUsage.filter((value) => value !== valueToRemove);
    setValue('street_usages', valueToSet);
  };

  return (
    <div className="form-group form-textarea">
      {withStreetUsage && (
        <>
          <label htmlFor='street_usages'>
            {t('survey.street_usage_label')}
          </label>
          <div className="form-input" style={{marginBottom: '2em'}}>
            <Controller
              name="street_usages"
              control={control}
              render={() => (
                <Select 
                  fullWidth
                  id="street_usages" 
                  name='street_usages' 
                  sx={{
                    fontSize: '1em',
                    borderRadius: '1.1rem',
                  }}
                  multiple
                  inputProps={{
                    sx: {
                      padding: '1.1rem',  
                      borderRadius: '1.1rem',
                    }
                  }}
                  displayEmpty
                  value={valueStreetUsage}
                  renderValue={(selected) => {
                    if ( selected.length > 0 ) {
                      return (
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                          {selected.map((value) => (
                            <Chip 
                              key={value} 
                              label={listStreetUsageOptions.find(elem => elem.value === value).label} 
                              style={{
                                fontSize: '0.8em',
                                fontWeight: 700
                              }}
                              onMouseDown={(event) => event.stopPropagation()}
                              onDelete={(e) => {
                                e.stopPropagation();
                                handleDelete(value);
                              }}
                            />
                          ))}
                        </Box>
                      );
                    } else {
                      return (
                        <p>
                          {t('criteria.street_usage_placeholder')}
                        </p>
                      );
                    }
                  }}
                  onChange={handleChange}
                >
                  {listStreetUsageOptions.map((elem, index) => (
                    <MenuItem key={index} value={elem.value}>
                      <p style={{fontSize: '1.5em'}}>{elem.label}</p>
                    </MenuItem>
                  ))}
                </Select>
              )}
            />
          </div>
        </>
      )}
      {surveyWithComment && (
        <>
          <label htmlFor="comments">{t('survey.comment_explain')}</label>
          <div className="form-input">
            <textarea 
              className="form-text" 
              name="comments" 
              id="comments" 
              maxLength={400} 
              {...register('comment')}
            />
          </div>
          <div className="form-tooltip">
            <small>{t('survey.helper_explain')}</small>
          </div>
        </>
      )}
    </div>
  );
};